import { createSlice } from "@reduxjs/toolkit";
import { blogGet, getBlogById } from "reduxStore/actions/blog";

const initialState = {
    userLoading: false,
    blogs: [],
    pagination: {
        current_page: 1,
        total_pages: 1,
        total_items: 0,
        items_per_page: 6,
        has_next_page: false,
        has_prev_page: false,
    },
    blog: null,
    error: null,
}

const blogSlice = createSlice({
    name: 'blog',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(blogGet.fulfilled, (state, action) => {
            const { blogs = [], pagination = {} } = action.payload || {};
            if (pagination.current_page > 1) {
                // Append for infinite scroll
                state.blogs = [...state.blogs, ...blogs];
            } else {
                // First page or refresh
                state.blogs = blogs;
            }
            state.pagination = pagination;
            state.userLoading = false;
        })
        .addCase(blogGet.pending, (state) => {
            state.userLoading = true;
        })
        .addCase(blogGet.rejected, (state, action) => {
            state.userLoading = false;
            state.error = action.payload;
        })
        .addCase(getBlogById.fulfilled, (state, action) => {
            state.blog = action.payload;
            state.userLoading = false;
        })
        .addCase(getBlogById.pending, (state) => {
            state.userLoading = true;
            state.blog = null;
        })
        .addCase(getBlogById.rejected, (state, action) => {
            state.userLoading = false;
            state.error = action.payload;
        })
    }
})

export default blogSlice.reducer;